
export default {
  mounted(el, binding) {
    console.log(binding.value)
    el.parentElement.classList.add('mk-text-overflow')
    let currentWidth = el.offsetWidth
    let parentWidth = el.parentElement.offsetWidth
    el.addEventListener('mouseover', () => {
      if (currentWidth > parentWidth) {
        el.setAttribute('title', binding.value || el.innerText)
      } else {
        el.removeAttribute('title')
      }
    })
  }
}